// src/components/ProductDetailPage.js

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/Productdetail.css';
import products from '../productData';

const ProductDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Find the selected product
  const product = products.find((prod) => prod.id === parseInt(id));

  // Handle case where the product is not found
  if (!product) {
    return <p className="not-found">Product not found!</p>;
  }

  return (
    <div className="product-detail-page">
      <div className="product-detail-container">
        <img src={product.image} alt={product.name} className="product-detail-image" />
        <div className="product-detail-info">
          <h2 className="product-detail-name">{product.name}</h2>
          <p className="product-detail-description">{product.description}</p>
          
          {/* Back to Products Button */}
          <button className="back-button" onClick={() => navigate('/products')}>
            Back to Products
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;
